import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import AddressPicker from './AddressPicker'
import Facilities from './Facilities'

import classes from './NewFamilyView.module.scss'

const NewFamilyView = ({ onBack }) => {
  const { t } = useTranslation()
  const nearbyCommunities = useSelector(state => state.studentDashboard.nearbyCommunities)

  return (
    <div>
      {onBack && (
        <div className='d-flex justify-content-end mb-3'>
          <button className={classes.backLink} onClick={onBack}>
            {t('dashboard.student.enrolledFamilyView.backToMyCommunities')}
          </button>
        </div>
      )}
      {nearbyCommunities ? (
        <Facilities />
      ) : (
        <AddressPicker isExploring={!!onBack} />
      )}
    </div>
  )
}

NewFamilyView.propTypes = {
  onBack: PropTypes.func,
}

export default NewFamilyView
